<template>
    <div>
        <ValidationObserver ref="filterForm">
            <b-row>
                <b-col cols="12" md="4">
                    <ValidationProvider name="academic_year" rules="required" v-slot="{ errors }">
                        <b-form-group :label="$t('academic_year')">
                            <academic-years-selectbox
                                v-model="filter.academic_year"
                                :validate-error="errors[0]"
                            />
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="4">
                    <ValidationProvider name="semester" rules="required" v-slot="{ errors }">
                        <b-form-group :label="$t('semester')">
                            <parameter-selectbox
                                code="semester"
                                v-model="filter.semester"
                                :validate-error="errors[0]"
                                :state="errors[0] ? false : null"
                            />
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="4">
                    <b-form-group :label="$t('report_type')">
                        <multi-selectbox
                            :allow-empty="false" :multiple="false"
                            :options="responseTypeOptions" v-model="responseType"
                        />
                    </b-form-group>
                </b-col>
                <b-col cols="12">
                    <b-button variant="primary" :disabled="processing" @click="getReport">
                        {{ $t('get_report').toUpper() }}
                    </b-button>
                </b-col>
            </b-row>
        </ValidationObserver>
    </div>
</template>

<script>
import {ValidationObserver, ValidationProvider} from 'vee-validate'

import AcademicYearsSelectbox from '@/components/interactive-fields/AcademicYearsSelectbox.vue'
import ParameterSelectbox from '@/components/interactive-fields/ParameterSelectbox.vue'
import MultiSelectbox from '@/components/interactive-fields/MultiSelectbox'

import LecturerReportService from '@/services/LecturerReportService'

export default {
    name: 'CourseSectionsScheduleComparisonReport',
    components: {
        ValidationObserver,
        ValidationProvider,
        AcademicYearsSelectbox,
        ParameterSelectbox,
        MultiSelectbox
    },
    data() {
        return {
            filter: {
                academic_year: null,
                semester: null
            },
            processing: false,
            responseType: 'excel',
            responseTypeOptions: [
                {value: 'excel', text: this.$t('excel')},
                {value: 'pdf', text: 'PDF'}
            ]
        }
    },
    methods: {
        async getReport() {
            if (this.processing) return

            this.processing = true
            try {
                const isValid = await this.$refs.filterForm.validate()
                if (!isValid) return

                const responseType = this.responseType
                const response = await LecturerReportService.getCourseSectionsScheduleComparisonReport({
                    params: {
                        ...this.filter,
                        response_type: responseType
                    },
                    responseType: 'arraybuffer'
                })
                const extension = responseType === 'excel' ? 'xlsx' : 'pdf'
                this._downloadFile(response, `course_sections_schedule_comparison_report.${extension}`)
            } catch (error) {
                this.showErrors(error)
            } finally {
                this.processing = false
            }
        }
    }
}
</script>
